module.exports = __webpack_public_path__ + "static/img/JO@3x.84a470b2.jpg";